import { createContext, useContext, useState } from "react";

const SessionContext = createContext();

const getUUID = () => crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substring(2) + Date.now().toString(36);

export const SessionProvider = ({ children }) => {
  const [sessionId, setSessionId] = useState(getUUID());

  const generateNewSession = () => {
    const newId = getUUID();
    setSessionId(newId);
    return newId;
  };

  return (
    <SessionContext.Provider
      value={{
        sessionId,
        generateNewSession,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);
